import React from 'react';
import { BookOpen, Briefcase, Globe, Users } from 'lucide-react';

export const AboutSection = () => {
  const pillars = [
    { icon: BookOpen, title: 'Education & Professional Development' },
    { icon: Briefcase, title: 'Economic Opportunity & Pathways' },
    { icon: Globe, title: 'Closing the Gap — Humanitarian Action' },
    { icon: Users, title: 'Ethical Governance & Community' }
  ];

  return (
    <section id="about" className="py-20" style={{ backgroundColor: 'var(--white-soft)' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Decorative Rule */}
        <div className="decorative-rule mb-16"></div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-16">
          {/* Left: Pull Quote */}
          <div className="flex items-center">
            <blockquote className="lhsc-pull-quote text-3xl md:text-4xl">
              "Education opens doors. Redistribution keeps them open."
            </blockquote>
          </div>

          {/* Right: Body Copy */}
          <div className="lhsc-body space-y-6">
            <p>
              What started as an online community of dreamers, builders, and hustlers has evolved into something much bigger. 
              The Lady Hustler Society Club is a registered nonprofit organization uniting female entrepreneurs and professionals across the globe.
            </p>
            <p>
              We exist to close gaps — in access, opportunity, education, and economic power. From Montreal to 25+ countries around the world, 
              we're building a movement where women don't just receive resources — they become part of the system that redistributes them.
            </p>
          </div>
        </div>

        {/* Four Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="p-6 border border-[var(--pink-dusty)] bg-white"
              style={{ borderTopWidth: '4px', borderTopColor: 'var(--blue-periwinkle)' }}
            >
              <pillar.icon size={32} className="mb-4" style={{ color: 'var(--mauve-rose)' }} />
              <h3 className="lhsc-subheading text-xs">{pillar.title}</h3>
            </div>
          ))}
        </div>

        {/* Our Stance */}
        <div className="max-w-4xl mx-auto">
          <h3 className="lhsc-heading text-2xl mb-6 text-center">Our Stance</h3>
          <div className="lhsc-body space-y-6">
            <p>
              We are not here to romanticize struggle. We are here to change the conditions that make it necessary. 
              That's why The Lady Hustler Society Club exists as a registered nonprofit association — not to glorify hustle, but to organize it.
            </p>
            <p>
              To take the invisible labor, unpaid resilience, and quiet perseverance women carry every day, and turn it into access, opportunity, 
              and shared progress. Through education, economic pathways, and community-led redistribution, we build systems where effort is not 
              wasted — and growth doesn't depend on luck, proximity, or privilege.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
